var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"验证","visible":_vm.show,"width":"660px"},on:{"update:visible":function($event){_vm.show=$event},"close":_vm.handleClose}},[_c('div',{staticClass:"validate-qrcode-pop-wrap"},[_c('img',{staticClass:"qrcode-img",attrs:{"src":_vm.imgUrl,"alt":""}}),_c('p',{staticClass:"tip-text"},[_vm._v("请用手机扫描上方二维码进行人脸识别验证")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }